import { CalloutColor } from '../../../model';

export interface ColorClasses {
  border: string;
  text: string;
  gutter: string;
  gutterStrokeCssVar: string;
  bg: string;
}

export interface ColorOption {
  label: string;
  value: CalloutColor;
  colorClass: string;
}

export const colorToLabel: Record<CalloutColor, string> = {
  [CalloutColor.Teal]: 'Teal',
  [CalloutColor.Indigo]: 'Indigo',
  [CalloutColor.Yellow]: 'Yellow',
  [CalloutColor.Red]: 'Red',
  [CalloutColor.Gray]: 'Gray',
};

export const colorClassMap: Record<CalloutColor, ColorClasses> = {
  [CalloutColor.Teal]: {
    border: 'border-teal-500 dark:border-teal-300',
    text: 'text-teal-600 dark:text-teal-600',
    gutter: 'text-teal-500 dark:text-teal-300',
    gutterStrokeCssVar: '--teal-500',
    bg: 'bg-teal-500',
  },
  [CalloutColor.Indigo]: {
    border: 'border-indigo-500 dark:border-indigo-300',
    text: 'text-indigo-600 dark:text-indigo-600',
    gutter: 'text-indigo-500 dark:text-indigo-300',
    gutterStrokeCssVar: '--indigo-500',
    bg: 'bg-indigo-500',
  },
  [CalloutColor.Yellow]: {
    border: 'border-amber-500 dark:border-amber-300',
    text: 'text-amber-600 dark:text-amber-600',
    gutter: 'text-amber-500 dark:text-amber-300',
    gutterStrokeCssVar: '--amber-500',
    bg: 'bg-amber-500',
  },
  [CalloutColor.Red]: {
    border: 'border-red-500 dark:border-red-300',
    text: 'text-red-600 dark:text-red-600',
    gutter: 'text-red-500 dark:text-red-300',
    gutterStrokeCssVar: '--red-500',
    bg: 'bg-red-500',
  },
  [CalloutColor.Gray]: {
    border: 'border-neutral-500 dark:border-neutral-300',
    text: 'text-neutral-600 dark:text-neutral-600',
    gutter: 'text-neutral-500 dark:text-neutral-300',
    gutterStrokeCssVar: '--neutral-500',
    bg: 'bg-neutral-500',
  },
};
